import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles2 = StyleSheet.create({
    contentContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 0,
    },
    mediaContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        marginTop: 20,
        marginBottom: 5,
        paddingHorizontal: 15,
        color: theme.colors.textPrimary,
        textAlign: 'center',
    },
    price: {
        paddingHorizontal: 10,
        paddingBottom: 5,
        fontSize: 20,
        fontWeight: '600',
        color: theme.colors.colorPrimary,
    },
    containerStock: {
        borderRadius: 10,
        backgroundColor: theme.colors.neutralGray,
        padding: 2,
        margin: 10,
    },
    stock: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.darkGray,
        paddingHorizontal: 15,
        marginVertical: 5,
    },
    description: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        marginVertical: 10,
        paddingHorizontal: 25,
        textAlign: 'center',
        lineHeight: 20,
    },
    details: {
        fontSize: 14,
        color: theme.colors.textSecondary,
        paddingHorizontal: 30,
        textAlign: 'center',
        lineHeight: 20,
    },
    buttonContainer: {
        flexDirection: 'column',
        // position: 'absolute',
        marginTop: 0,
        padding: 15,
        bottom: 15,
        width: '100%',
    },
    buttonContainer2: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 5,
        bottom: 15,
        width: '100%',
    },
    mainButton: {
        width: '100%',
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    messageContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        padding: 10,
        marginVertical: 10,
        borderRadius: 5,
    },
    benefitAsset: {
        width: 120,
        height: 120,
    },
    messageText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    descriptionText: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
    },
    spacer2: {
        height: 80,
    },
})

export default styles2
